import {
	API2_URL, GROUPS_PHASES_REQUEST, GROUPS_PHASES_LIST, GROUPS_PHASES_EDIT,
	GROUPS_PHASES_CLEAR, GROUPS_PHASES_FAIL
} from "../store/config";
import fetch from "isomorphic-fetch";
import {newNotification} from "./notifications";
import _ from 'lodash';
import {history} from "../store/store";
import {sessionService} from "redux-react-session";

export const fetchGroupsPhasesShow = (page = 1) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(groupsRequest());
				return fetch(`${API2_URL}/phases/groups?include[0]=status&page=${page}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(groupsListData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(groupsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

export const fetchGroupsPhasesList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(groupsRequest());
				return fetch(`${API2_URL}/phases/groups?include[0]=status&per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(groupsListData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(groupsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

export const fetchGroupPhaseEdit = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(groupsRequest());
				dispatch(groupsClear());
				return fetch(`${API2_URL}/phases/groups/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(groupsEditData(json)),
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: _.values(error), type: "danger"}));
							return dispatch(groupsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

export const groupPhaseSave = (data) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(data)
				};

				dispatch(groupsRequest());
				return fetch(`${API2_URL}/phases/groups${data.id ? `/${data.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message, type: "success"}));
							if(data.id){
								return dispatch(groupsEditData(json))
							}else {
								history.push(`/fases/grupos/editar/${json.data.id}`);
							}
						},
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(groupsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

export const groupPhaseDelete = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'delete'
				};

				dispatch(groupsRequest());
				return fetch(`${API2_URL}/phases/groups/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(fetchGroupsPhasesShow());
							dispatch(newNotification({title: "Éxito", content: json.message, type: "success"}));
						},
						error => {
							dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(groupsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

const groupsRequest = () => {
	return {
		type: GROUPS_PHASES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const groupsListData = (json) => {
	return {
		type: GROUPS_PHASES_LIST,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const groupsEditData = (json) => {
	return {
		type: GROUPS_PHASES_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}

}

const groupsClear = () => {
	return {
		type: GROUPS_PHASES_CLEAR,
		payload: {},
		timestamp: Date.now()
	}

}

const groupsFail = (error) => {
	return {
		type: GROUPS_PHASES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/groups_phases.js